"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../base-components/Icon/Icon");
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
var _ComponentHeader = require("../../base-components/ComponentHeader/ComponentHeader");
var _AccordionContainer = require("./AccordionContainer");
var _AccordionItem = require("./AccordionItem");
var _AccordionPanel = require("./AccordionPanel");
var _AccordionBody = require("./AccordionBody");
var _helpers = require("./helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Panel = function Panel(accordionProps) {
  return function (propsFromAccordionItem) {
    return /*#__PURE__*/_react["default"].createElement(_AccordionPanel.AccordionPanel, _extends({}, propsFromAccordionItem, {
      styles: accordionProps.styles
    }), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, _extends({}, accordionProps.leftSectionProp, {
      styles: {
        icon: accordionProps.styles.leftIcon
      }
    })), /*#__PURE__*/_react["default"].createElement("div", accordionProps.middleSectionProp), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, _extends({}, accordionProps.rightSectionProp, {
      styles: {
        icon: propsFromAccordionItem.toggled ? accordionProps.styles.rightIconToggled : accordionProps.styles.rightIcon
      }
    })));
  };
};
var Body = function Body(accordionProps) {
  return function (propsFromAccordionItem) {
    return /*#__PURE__*/_react["default"].createElement(_AccordionBody.AccordionBody, _extends({}, propsFromAccordionItem, accordionProps.remainingBodyProps, {
      styles: accordionProps.styles
    }));
  };
};
var Accordion = exports.Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);
  var _super = _createSuper(Accordion);
  function Accordion() {
    _classCallCheck(this, Accordion);
    return _super.apply(this, arguments);
  }
  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        titleProps = _this$props.titleProps,
        bodyProps = _this$props.bodyProps,
        panelMiddleSectionProps = _this$props.panelMiddleSectionProps,
        panelLeftSectionProps = _this$props.panelLeftSectionProps,
        panelRightSectionProps = _this$props.panelRightSectionProps,
        toggledItems = _this$props.toggledItems,
        styles = _this$props.styles,
        namespace = _this$props.namespace,
        qeId = _this$props.qeId;
      return /*#__PURE__*/_react["default"].createElement(_AccordionContainer.AccordionContainer, {
        styles: styles
      }, title && /*#__PURE__*/_react["default"].createElement(_ComponentHeader.ComponentHeader, _extends({
        title: title,
        styles: styles
      }, titleProps, {
        namespace: namespace
      })), (0, _helpers.transformProps)({
        styles: styles,
        bodyProps: bodyProps,
        panelMiddleSectionProps: panelMiddleSectionProps,
        panelLeftSectionProps: panelLeftSectionProps,
        panelRightSectionProps: panelRightSectionProps
      }).map(function (props, i) {
        var key = props.key || "accordion-item-".concat(i);
        var toggled = (0, _helpers.shouldToggleAccordionItem)(toggledItems, i);
        return /*#__PURE__*/_react["default"].createElement(_AccordionItem.AccordionItem, {
          key: key,
          initiallytoggled: toggled,
          namespace: namespace,
          Panel: Panel(props),
          Body: Body(props),
          onExpand: props.onExpand,
          onCollapse: props.onCollapse,
          qeId: qeId ? "".concat(qeId, "__accordion-").concat(i + 1) : undefined
        });
      }));
    }
  }]);
  return Accordion;
}(_react["default"].Component);
_defineProperty(Accordion, "Container", _AccordionContainer.AccordionContainer);
_defineProperty(Accordion, "Item", _AccordionItem.AccordionItem);
_defineProperty(Accordion, "Panel", _AccordionPanel.AccordionPanel);
_defineProperty(Accordion, "Body", _AccordionBody.AccordionBody);
_defineProperty(Accordion, "propTypes", {
  title: _propTypes["default"].string,
  titleProps: _propTypes["default"].shape({
    Component: _propTypes["default"].node
  }),
  panelLeftSectionProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].arrayOf(_propTypes["default"].object)]),
  panelMiddleSectionProps: _propTypes["default"].arrayOf(_propTypes["default"].object),
  panelRightSectionProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].arrayOf(_propTypes["default"].object)]),
  bodyProps: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  styles: _propTypes["default"].shape({
    accordionContainer: _propTypes["default"].string,
    accordionItem: _propTypes["default"].string,
    accordionPanel: _propTypes["default"].string,
    accordionBody: _propTypes["default"].string,
    'accordionBody--hidden': _propTypes["default"].string,
    leftIcon: _propTypes["default"].string,
    rightIcon: _propTypes["default"].string,
    rightIconToggled: _propTypes["default"].string
  }),
  toggledItems: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].number), _propTypes["default"].number]),
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string
});
_defineProperty(Accordion, "defaultProps", {
  title: null,
  titleProps: {
    Component: undefined
  },
  panelLeftSectionProps: {
    Svg: function Svg() {
      return (0, _svgFetcher["default"])('polygon-arrow', 'us-commercial');
    },
    styles: {}
  },
  panelMiddleSectionProps: [],
  panelRightSectionProps: {
    Svg: function Svg() {
      return (0, _svgFetcher["default"])('dropdown-arrow', 'us-commercial');
    },
    styles: {}
  },
  bodyProps: [],
  styles: {},
  toggledItems: [],
  namespace: '',
  qeId: undefined
});